import API from "serviceshift-ui/api-client";

// Shapes from Admin::V4::ApiDocsController: the integrations read API's
// tenant-facing docs, rendered on the server from docs/integrations-api, for
// the API access page's Docs tab. Quiet like the API keys: the tab shows its
// own errors.

export interface ApiDocsPageLink {
  slug: string;
  title: string;
}

export interface ApiResource {
  name: string;
  label: string;
  // The path param, named like the webhook events' id field.
  param: string;
  path: string;
  scope: string;
  page: string;
  section: string | null;
}

export interface ApiDocsIndex {
  data: ApiDocsPageLink[];
  meta: {
    // The API host, https://api.sera.tech in production.
    base_url: string;
    resources: ApiResource[];
  };
}

export interface ApiDocsPage {
  slug: string;
  title: string;
  // Sanitized on the server.
  html: string;
}

const BASE = "/admin/v4/api_docs";
const QUIET = { headers: { ignoreError: true } };

export default {
  async fetchApiDocs(): Promise<ApiDocsIndex> {
    return (await API.makeRequest<ApiDocsIndex>(BASE, QUIET)).data;
  },

  async fetchApiDocsPage(_: unknown, slug: string): Promise<ApiDocsPage> {
    return (
      await API.makeRequest<{ data: ApiDocsPage }>(
        `${BASE}/${encodeURIComponent(slug)}`,
        QUIET
      )
    ).data.data;
  }
};
